import React, { FC } from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { SelectProps } from '../../Interface/Index';

const SelectComponent: FC<SelectProps> = ({
  onChange,
  value,
  label,
  options,
  multiple = false,
  displayEmpty,
  renderValue
}) => {
  const shouldShrink = !!value && (multiple ? (value as any[]).length > 0 : !!value);
  return (
    <FormControl fullWidth size="small">
      <InputLabel shrink={shouldShrink || displayEmpty}>{label}</InputLabel>
      <Select
        value={value || (multiple ? [] : '')}
        label={label}
        onChange={onChange}
        multiple={multiple} 
        displayEmpty={displayEmpty}
        renderValue={
          renderValue ||
          ((selected) =>
            multiple
              ? (selected as any[])
                  .map((val) => options.find((o) => o.value === val)?.label)
                  .join(', ')
              : options.find((o) => o.value === selected)?.label || '')
        }
      >
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default SelectComponent;
